export enum SmartDealState {
  Draft = 'Draft',
  Blockchain = 'Blockchain',
}

